import {SHOW_HTML_IN_MENU} from "../../../config/config"

const DEFAULT_MENU = [
  { name: 'geo', title: 'Территориальная схема', number: '01',
    childs: [
      {name: 'geo.objects'},
      {name: 'geo.treads'},
      {name: 'geo.forecasts'},
      {name: 'geo.apos'}
    ]
  },
  { name: 'atu'},
  { name: 'target'},
  { name: 'garbage',
    childs: [
      {
        name: 'garbage.organizations'
      },
      {
        name: 'garbage.defenses'
      },
      {
        name: 'garbage.medics'
      },
      {
        name: 'garbage.individualAreas'
      },
      {
        name: 'garbage.garages'
      },
      {
        name: 'garbage.apartmentBuildings'
      }
    ]
  },
  { name: 'msn',
    childs: [
      {
        name: 'msn.withContainers'
      },
      {
        name: 'msn.withoutContainers'
      },
      {
        name: 'msn.separateCollections'
      }
    ]
  },
  { name: 'unauthorized',
    childs: [
      {
        name: 'unauthorized.heaps'
      },
      {
        name: 'unauthorized.wpf'
      }
    ]
  },
  { name: 'garbageObjectRegistry', title: 'Реестр объектов по обращению с отходами', number: '07'},
  { name: 'registry', title: 'Реестры', number: '08',
    childs: [
      {
        name: 'registry.operators'
      },
      {
        name: 'registry.contracts'
      }
    ]
  },
  { name: 'analytic', title: 'Аналитика', number: '09'},
  { name: 'classifier', title: 'Кадастр отходов', number: '10',
    childs: [
      {name: 'classifier.fkko'},
      {name: 'classifier.groro'},
      {name: 'classifier.tech'},
      {name: 'classifier.garbage'}
    ]
  },
  { name: 'regionalOperators', title: 'Региональные операторы', number: '11'},
  {
    name: 'access',
    childs: [
      { name: 'access.users'},
      { name: 'access.usersGroups'},
      { name: 'access.journals'},
      { name: 'access.backups'}
    ]
  },
  {
    name: 'calculation',
    childs: [
      {
        name: 'calculation.regionalTariffs'
      }
    ]
  }
]

if (SHOW_HTML_IN_MENU && SHOW_HTML_IN_MENU === true) {
  DEFAULT_MENU.push({
    name: 'verstka',
    childs: [
      {name: 'verstka.navigationControlPage'},
      {name: 'verstka.navigationControlCarPage'},
      {name: 'verstka.routesPage'},
      {name: 'verstka.routeOnePage'},
      {name: 'verstka.routeSchedulePage'},
      {name: 'verstka.analyticsChartsNew'},
      {name: 'verstka.balance'},
      {name: 'verstka.reestrDocs'},
      {name: 'verstka.reestr'}
    ]
  })
}

export default DEFAULT_MENU
